export function copyTableAsHTML(table: HTMLTableElement) {
  const html = table.outerHTML;

  const blob = new Blob([html], { type: 'text/html' });
  const clipboardItem = new ClipboardItem({ 'text/html': blob });

  navigator.clipboard.write([clipboardItem]);
}

export function copyTableAsText(table: HTMLTableElement) {
  const rows = Array.from(table.rows).map((row) =>
    Array.from(row.cells)
      .map((cell) => cell.innerText.trim())
      .join('\t'),
  );

  const text = rows.join('\n');
  navigator.clipboard.writeText(text);
}

export function copyTable(ref: React.RefObject<HTMLTableElement | null>) {
  if (!ref.current) return;

  if ('ClipboardItem' in window) {
    copyTableAsHTML(ref.current);
  } else {
    copyTableAsText(ref.current);
  }
}
